import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { SistemaDatosService } from '@app/core/services/sistema-datos.service';
import { SystemSettingsService } from '@app/core/services/system-settings.service';

@Component({
    selector: 'app-footer',
    templateUrl: './app-footer.component.html',
    styleUrls: ['./app-footer.component.scss'],
    standalone: false
})
export class AppFooterComponent implements OnInit {
    footerTitle: string = 'Calfrac SIGD';

    constructor(
        private sistemaSvc: SistemaDatosService,
        private settingsSvc: SystemSettingsService,
        private cdRef: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        // Cargar desde BD
        this.sistemaSvc.get().subscribe({
            next: (d) => {
                if (d?.titulo && d.titulo.trim().length > 0) {
                    this.footerTitle = d.titulo.trim();
                    this.cdRef.markForCheck();
                }
            },
            error: () => {}
        });

        // Fallback desde settings locales (administracion-blister)
        try {
            const s: any = this.settingsSvc.get('administracion-blister' as any);
            if (s?.systemTitle && String(s.systemTitle).trim().length > 0) {
                this.footerTitle = String(s.systemTitle).trim();
            }
        } catch {}
    }
}
